// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"tornaEnrere_breadcrumb__9fXKH","icona":"tornaEnrere_icona__q5jbJ","text":"tornaEnrere_text__Y_3aX"};